/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 09:46:58
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-15 17:42:47
 */
import React, { ReactElement, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { DisqualificationBreakageManagementList } from './disqualificationBreakageManagement/disqualificationBreakageManagement'
import { DrugQualityFileList } from './drugQualityFile/drugQualityFile'
import { PharmaceuticalDestructionRecordList } from './pharmaceuticalDestructionRecord/pharmaceuticalDestructionRecord'
import { ProductWithdrawalManagementList } from './productWithdrawalManagement/productWithdrawalManagement'
import { RecentTimeDrugCollectionEffortList } from './RecentTimeDrugCollectionEfforts/recentTimeDrugCollectionEfforts'
import { RecordOfAdverseReactionsList } from './recordOfAdverseReactions/recordOfAdverseReactions'
import { UnqualifiedMedicinesLedgerList } from './unqualifiedMedicinesLedger/unqualifiedMedicinesLedger'

export const QualityManagementTabs = (): ReactElement => {
  const location: any = useLocation()

  const [selectKey, setSelectKey] = useState<any>('0')

  return (
    <TabBar
      style={{ margin: '10px 20px' }}
      defaultActiveKey={
        location.state ? location.state.selectKey : selectKey || '0'
      }
      onChange={(v) => {
        setSelectKey(v)
      }}
    >
      <TabPane key='0' tab='药品质量档案'>
        <DrugQualityFileList selectKey={selectKey}></DrugQualityFileList>
      </TabPane>
      <TabPane key='1' tab='不良反应记录'>
        <RecordOfAdverseReactionsList selectKey={selectKey}></RecordOfAdverseReactionsList>
      </TabPane>
      <TabPane key='2' tab='不合格报损管理'>
        <DisqualificationBreakageManagementList selectKey={selectKey}></DisqualificationBreakageManagementList>
      </TabPane>
      <TabPane key='3' tab='不合格药品台账'>
        <UnqualifiedMedicinesLedgerList selectKey={selectKey}></UnqualifiedMedicinesLedgerList>
      </TabPane>
      <TabPane key='4' tab='药品销毁记录'>
        <PharmaceuticalDestructionRecordList selectKey={selectKey}></PharmaceuticalDestructionRecordList>
      </TabPane>
      <TabPane key='5' tab='商品停售管理'>
        <ProductWithdrawalManagementList selectKey={selectKey}></ProductWithdrawalManagementList>
      </TabPane>
      <TabPane key='6' tab='近效期药品催销表'>
        <RecentTimeDrugCollectionEffortList selectKey={selectKey}></RecentTimeDrugCollectionEffortList>
      </TabPane>
    </TabBar>
  )
}
